export type BlogAuthor = {
  name: string;
  jobTitle: string;
  /** Site-relative path so Person.url / byline stay on the current regional host. */
  profileUrl: string;
  /** Site-relative path to a small headshot, shown next to the byline wherever it renders. */
  avatarUrl?: string;
  sameAs?: string[];
};

/** Default byline for blog posts; links to the founder story for E-E-A-T context. */
export const DEFAULT_BLOG_AUTHOR: BlogAuthor = {
  name: "Patrick",
  jobTitle: "Founder",
  profileUrl: "/blogs/the-best-personal-financial-software",
  avatarUrl: "/blog/images/patrick-founder.jpg",
  sameAs: [
    "https://www.youtube.com/@wheredoesmymoneygo",
    "https://www.facebook.com/profile.php?id=61560451584182",
    "https://www.instagram.com/wheredoesmymoneygo.info/",
  ],
};

export function blogAuthorPersonJsonLd(author: BlogAuthor, origin: string) {
  const url = /^https?:\/\//i.test(author.profileUrl)
    ? author.profileUrl
    : `${origin}${author.profileUrl}`;
  return {
    "@type": "Person" as const,
    name: author.name,
    url,
    jobTitle: author.jobTitle,
    ...(author.sameAs?.length ? { sameAs: author.sameAs } : {}),
  };
}
